import request from "./request.js";

// 获取老师详情
export let getProfile = data => {
  return request("/edu/teacher/getMyProfile", data);
};

// 取消关注老师
export let cancelFollow = data => {
  return request("/edu/student/cancelFollow", data);
};

// 关注老师
export let followTeacher = data => {
  return request("/edu/student/followTeacher", data);
};

// 获取老师个人信息
export let getBaseProfile = data => {
  return request("/edu/teacher/getBaseProfile", data);
};

// 获取老师列表
export let getTeacherList = data => {
  return request("/edu/teacher/getTeacherList", data);
};

// 完善/修改老师资料
export let perfectMyProfile = data => {
  return request("/edu/teacher/perfectMyProfile", data);
};

// 获取默认银行地址
export let getMyBankList = data => {
  return request("/user/bank/getMyBankList", data);
};

// 添加银行
export let createBank = data => {
  return request("/user/bank/create", data);
};

// 修改银行
export let modifyBank = data => {
  return request("/user/bank/modify", data);
};

// 获取排课详细
// export let getSchedule = data => {
//   return request("/edu/teacher/schedule/getSchedule", data);
// };

// 获取排课列表
export let getScheduleListByTeacherId = data => {
  return request("/edu/teacher/schedule/getScheduleListByTeacherIdV2", data);
};

// 添加排课设置
export let scheduleCreate = data => {
  return request("/edu/teacher/schedule/create", data);
};

// 修改排课设置
export let scheduleModify = data => {
  return request("/edu/teacher/schedule/modify", data);
};

// 获取课时统计
export let getOrderCourseStats = data => {
  return request("/edu/course/getOrderCourseStats", data);
};

// 获取老师被预约时间
export let getTeacherAppointedTimeList = data => {
  return request("/edu/teacher/getTeacherAppointedTimeList", data);
};

// 获取我的学生列表
export let getMyStudentList = data => {
  return request("/edu/teacher/getMyStudentList", data);
};

// 获取我教导的课程
export let getMyTeachingCourseList = data => {
  return request("/edu/course/getMyTeachingCourseList", data);
};

// 获取我的收入概况
export let getMyAmount = data => {
  return request("/edu/teacher/getMyIncome", data);
};

// 获取我的结算明细
export let getMySettleList = data => {
  return request("/edu/teacher/getMySettleList", data);
};

// 获取我的每个月报告清单
export let getTeachingChecklist = data => {
  return request("/edu/teacher/teachingCheck/getTeachingCheckList", data);
};

// 提交每月报告评价
export let createReport = data => {
  return request("/edu/teacher/teachingCheck/comment/create", data);
};

// 获取改签详情
export let getChangeApply = data => {
  return request("/edu/course/order/getChangeApply", data);
};

// 改签审核
export let checkChange = data => {
  return request("/edu/course/order/changeApply/check", data);
};

// 课程邀约
export let askCourse = data => {
  return request("/edu/course/inviteOrder/create", data);
};


// 获取学校列表
export let getSchoolList = data => {
  return request("/edu/school/getSchoolList", data);
};
// 获取学院列表
export let getCollegeList = data => {
  return request("/edu/school/getCollegeList", data);
};
// 删除接口
export let scheduleDel = data => {
  return request("/edu/teacher/schedule/delete", data);
};

// 老师注册通过邮箱
export let regTeacherByEmail = data => {
  return request("/edu/student/regTeacherByEmail", data);
};
// 老师注册通过手机
export let regTeacherByMobile = data => {
  return request("/edu/student/regTeacherByMobile", data);
};